import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Panel, PanelGroup } from "react-bootstrap";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";

import Loading from "../../common/Loading";

import { generateUniqueId } from "../../../utils";

import {
  calcDepartmentUtilizationRate,
  calcEmployeeUtilizationRate,
  getEmploymentStatusLabel
} from "./utils";

const EmployeeUtilizationList = ({ data, loading, monthColumns }) => {
  const [activeKey, setActiveKey] = useState(null);

  const handleSelect = (selectedKey) => {
    setActiveKey(selectedKey);
  };

  useEffect(() => {
    if (data && data.length) {
      setActiveKey(`${data[0]._id.department}`);
    }
  }, [data]);

  if (loading) {
    return (
      <div className="loading">
        <Loading />
      </div>
    );
  }
  if (!data || !data.length) {
    return (
      <div className="loading">
        <h4 style={{ opacity: 0.15 }}>No Data</h4>
      </div>
    );
  }

  return (
    <div className="content-wrapper">
      <PanelGroup
        accordion
        id="accordion-employee-utilization"
        activeKey={activeKey}
        onSelect={handleSelect}
      >
        {data.map((item) => (
          <Panel eventKey={`${item._id.department}`} key={generateUniqueId()}>
            <Panel.Heading>
              <Panel.Title toggle>
                {activeKey === `${item._id.department}` ? (
                  <IoChevronUp
                    size="1.3em"
                    style={{ verticalAlign: "middle", paddingRight: "5px" }}
                  />
                ) : (
                  <IoChevronDown
                    size="1.3em"
                    style={{ verticalAlign: "middle", paddingRight: "5px" }}
                  />
                )}
                {`${item.description}`}
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible style={{ overflow: "auto" }}>
              {activeKey === `${item._id.department}` && (
                <table>
                  <thead>
                    <tr
                      style={{
                        background: "#286090",
                        color: "white",
                        fontSize: 10
                      }}
                    >
                      <th>Employee</th>
                      {monthColumns?.map((month) => (
                        <th key={generateUniqueId()}>{month}</th>
                      ))}
                    </tr>
                    {/* USER ROWS */}
                    {item.employees.map((employee) => (
                      <tr key={employee.employee} style={{ fontSize: 12 }}>
                        <td>
                          {employee.employeeName}
                          {getEmploymentStatusLabel(employee.employmentStatus)}
                        </td>
                        {/* MONTH COLUMNS */}
                        {monthColumns.map((month) => (
                          <>
                            <td id={`${employee.employee}-${month}`}>
                              {employee.months.find(
                                (m) => `${m.month}-${m.year}` === month
                              )
                                ? `${calcEmployeeUtilizationRate(
                                    employee.months.find(
                                      (m) => `${m.month}-${m.year}` === month
                                    )
                                  )}%`
                                : "--"}
                            </td>
                          </>
                        ))}
                      </tr>
                    ))}
                    {/* TOTAL ROW */}
                    <tr style={{ fontWeight: "bold", fontSize: 12 }}>
                      <td>Full Department</td>
                      {monthColumns.map((month) => (
                        <>
                          <td id={`${item._id.department}-${month}`}>
                            {`${calcDepartmentUtilizationRate(item, month)}%`}
                          </td>
                        </>
                      ))}
                    </tr>
                  </thead>
                </table>
              )}
            </Panel.Body>
          </Panel>
        ))}
      </PanelGroup>
    </div>
  );
};

EmployeeUtilizationList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  monthColumns: PropTypes.array
};

export default EmployeeUtilizationList;
